import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FooterCopy } from '@models/cms/footer.model';
import { RouterModule } from '@angular/router';
import { LinkDisplayComponent } from '@components/link-display/link-display.component';
import {CultureKeyType, FALLBACK_CULTURE} from '@constants/app.constants';
import { FooterNavigationCopy } from '@models/cms/footer-navigation.model';
import {
  SocialMediaIconsComponent
} from "../../features/home/components/social-media-icons/social-media-icons.component";
import { GrowthBookFeatureKeys } from "@models/growthbook.models";
import { LetDirective } from "@directives/app-let.directive";
import { GrowthBookService } from "@services/growthbook/growthbook.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {CultureDropdownComponent} from "@components/culture-dropdown/culture-dropdown.component";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {selectCurrentCultureName} from "@selectors/culture.selector";
import {CultureResource} from "@models/resources/culture.model";
@Component({
  selector: 'app-footer-extended',
  standalone: true,
    imports: [CommonModule, RouterModule, LinkDisplayComponent, SocialMediaIconsComponent, LetDirective, CultureDropdownComponent],
  templateUrl: './footer-extended.component.html',
  styleUrls: ['./footer-extended.component.scss'],
})
export class FooterExtendedComponent implements OnInit {
  @Input() cmsCopy: FooterCopy;
  @Input() navCopy: FooterNavigationCopy;
  @Input() culture = FALLBACK_CULTURE;

  currentYear = new Date().getFullYear();
  cultureName$ = this.store.select(selectCurrentCultureName);
  cultures$: Observable<CultureResource[] | null>;

  protected readonly gbf = GrowthBookFeatureKeys;
  private readonly destroyRef = inject(DestroyRef);

  constructor(public gbs: GrowthBookService, private cd: ChangeDetectorRef, private store: Store) {
  }

  ngOnInit() {
    this.gbs.onChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.cd.detectChanges();
    });
  }
}
